// src/pages/admin/index.tsx
// import './index.css';

export default function AdminHome() {
  return <div>Admin Home</div>;
}
